// "Wrecks near me" and "Surprise me".
import { haversineM, distanceM, bearingDeg } from "./geo";

// Number(null) and Number("") are 0, which would put a wreck with a missing coordinate at 0°N 0°E.
const coord = (v) => (v === null || v === undefined || v === "" || typeof v === "boolean" ? NaN : Number(v));
const valid = (s) => Number.isFinite(coord(s?.lat)) && Number.isFinite(coord(s?.lng));

// The `count` wrecks closest to `point` ([lat, lng]), nearest first:
//   [{ ship, distanceM, bearing }]   (bearing = compass direction from the point to the wreck, in degrees)
// Cheap spherical distance picks the candidates; only the winners get the exact (ellipsoidal) distance.
export function nearestShips(ships, point, count = 10) {
  if (!Array.isArray(ships) || !point || !Number.isFinite(point[0]) || !Number.isFinite(point[1])) return [];
  return ships
    .filter(valid)
    .map((ship) => ({ ship, rough: haversineM(point, [Number(ship.lat), Number(ship.lng)]) }))
    .sort((a, b) => a.rough - b.rough || Number(a.ship.id) - Number(b.ship.id))
    .slice(0, Math.max(0, count))
    .map(({ ship }) => {
      const to = [Number(ship.lat), Number(ship.lng)];
      return { ship, distanceM: distanceM(point, to), bearing: bearingDeg(point, to) };
    })
    .sort((a, b) => a.distanceM - b.distanceM);
}

// A random wreck, never the one in `excludeId` when there's any other choice. `rng` is injectable for tests.
export function pickRandomShip(ships, excludeId = null, rng = Math.random) {
  const pool = (ships || []).filter(valid);
  if (!pool.length) return null;
  const others = excludeId == null ? pool : pool.filter((s) => Number(s.id) !== Number(excludeId));
  const from = others.length ? others : pool;
  return from[Math.min(from.length - 1, Math.floor(rng() * from.length))];
}
